import * as React from "react";

import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import styled from "@emotion/styled";
import {
  Card,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  Paper,
  TableContainer,
  TextField
} from "@mui/material";
import useIntranetPortalCoreApi from "../../../hooks/useIntranetPortalAdminApi";
import {
  type IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForNextWeekDto,
  type IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForThisWeekDto,
  type IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForTodayDto,
  LeaveDetailsService,
  type IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForThisMonthDto
} from "../../../services/intranet-portal-services";
import CustomTable from "../../../ui-component/CustomUiComponent/TableContainer";
import CustomPagination from "../../../ui-component/CustomUiComponent/Pagination";
import dayjs from "dayjs";
import Brightness6Icon from "@mui/icons-material/Brightness6";
import { type ReactTableColumn } from "@/types";
import debounce from "lodash.debounce";

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

interface AcknowledgementRequestColum
  extends IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForTodayDto {}

const MyProfileContainer = styled.div`
  /* background:red; */
`;

function TabPanel(props: TabPanelProps): React.ReactElement {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number): any {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`
  };
}

export default function leaveDetails(): React.ReactElement {
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const { handleRequest } = useIntranetPortalCoreApi();
  const [leaveDataForToday, setleaveDataForToday] =
    React.useState<IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForTodayDto[]>();
  const [leaveDataForThisWeek, setLeaveDataForThisWeek] =
    React.useState<IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForThisWeekDto[]>();
  const [leaveDataForNextWeek, setLeaveDataForNextWeek] =
    React.useState<IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForNextWeekDto[]>();
  const [leaveDateForThisMonth, setleaveDataForThisMonth] =
    React.useState<IntranetPortal_HRLeaveDetails_HRLeaveDetailsDtos_LeaveForThisMonthDto[]>();
  const [pageForToday, setPageForToday] = React.useState(0);
  const [pageForThisWeek, setPageForThisWeek] = React.useState(0);
  const [pageForNextWeek, setPageForNextWeek] = React.useState(0);
  const [pageForThisMonth, setPageForThisMonth] = React.useState(0);
  const [skipCountForToday, setSkipCountForToday] = React.useState(0);
  const [skipCountForThisWeek, setSkipCountForThisWeek] = React.useState(0);
  const [skipCountForNextWeek, setSkipCountForNextWeek] = React.useState(0);
  const [skipCountorForThisMonth, setSkipCountorForThisMonth] = React.useState(0);
  const [maxResultCountForToday, setMaxResultCountForToday] = React.useState(5);
  const [maxResultCountForThisWeek, setMaxResultCountForThisWeek] = React.useState(5);
  const [maxResultCountForNextWeek, setMaxResultCountForNextWeek] = React.useState(5);
  const [maxResultCountForThisMonth, setMaxResultCountForThisMonth] = React.useState(5);

  const [searchQuery, setSearchQuery] = React.useState("");
  const [filteredToday, setFilteredToday] = React.useState(leaveDataForToday);
  const [filteredThisWeek, setFilteredThisWeek] = React.useState(leaveDataForThisWeek);
  const [filteredNextWeek, setFilteredNextWeek] = React.useState(leaveDataForNextWeek);
  const [filteredThisMonth, setFilteredThisMonth] = React.useState(leaveDateForThisMonth);

  const debouncedSearch = React.useCallback(
    debounce((query: string) => {
      if (!query.trim()) {
        setFilteredToday(leaveDataForToday);
        setFilteredThisWeek(leaveDataForThisWeek);
        setFilteredNextWeek(leaveDataForNextWeek);
        setFilteredThisMonth(leaveDateForThisMonth);
        return;
      }

      const regex = new RegExp(query, "i");

      const filterFn = (list: any[]): any[] =>
        list?.filter(
          (item) => regex.test(item.employeeName ?? "") || regex.test(item.emailAddress ?? "")
        );

      setFilteredToday(filterFn(leaveDataForToday ?? []));
      setFilteredThisWeek(filterFn(leaveDataForThisWeek ?? []));
      setFilteredNextWeek(filterFn(leaveDataForNextWeek ?? []));
      setFilteredThisMonth(filterFn(leaveDateForThisMonth ?? []));
    }, 300), // 300ms debounce
    [leaveDataForToday, leaveDataForThisWeek, leaveDataForNextWeek, leaveDateForThisMonth]
  );

  React.useEffect(() => {
    debouncedSearch(searchQuery);
  }, [searchQuery, debouncedSearch]);

  // const id = user?.profile?.sub

  const column: Array<ReactTableColumn<AcknowledgementRequestColum>> = [
    {
      Header: "Name",
      accessor: "employeeName"
    },
    {
      Header: "Email",
      accessor: "emailAddress"
    },
    {
      Header: "Leave Type",
      accessor: "leaveStatus",
      Cell: ({ row }: any) => {
        const status = row.original.leaveStatus;
        return (
          <Chip
            size="small"
            label={
              <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
                {status === "First Half" ? (
                  <Brightness6Icon style={{ transform: "rotate(180deg)" }} />
                ) : status === "Second Half" ? (
                  <Brightness6Icon />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      position: "relative"
                    }}
                  >
                    <Brightness6Icon />
                    <Brightness6Icon
                      style={{
                        transform: "rotate(180deg)",
                        position: "absolute"
                      }}
                    />
                  </Box>
                )}
                {row.original.leaveStatus}
              </Box>
            }
            sx={{
              fontSize: "1rem",
              background: "#D42C2C",
              color: "white"
            }}
          />
        );
      }
    },
    {
      Header: "Leave Date",
      accessor: "leaveDate",
      Cell: ({ row }: any) => {
        const date = dayjs(row.original.leaveDate).format("D MMM YYYY");
        return <span>{date}</span>; // Changed this because it is sending build error
      }
    }
  ];

  const sortByDate = (leaves: any): any => {
    return leaves.sort((a: any, b: any) => {
      const dateA: any = new Date(a.leaveDate);
      const dateB: any = new Date(b.leaveDate);
      return dateA - dateB;
    });
  };

  const getLeaveForToday = async (): Promise<void> => {
    await handleRequest(() =>
      LeaveDetailsService.getCoreApiApiAppLeaveDetailsStaffOnLeaveForToday()
    ).then((response) => {
      if (response != null) {
        const sorted = sortByDate(response);
        setleaveDataForToday(sorted);
      }
    });
  };

  const getLeaveForThisWeek = async (): Promise<void> => {
    await handleRequest(() =>
      LeaveDetailsService.getCoreApiApiAppLeaveDetailsStaffOnLeaveForThisWeek()
    ).then((response) => {
      if (response != null) {
        const sorted = sortByDate(response);
        setLeaveDataForThisWeek(sorted);
      }
    });
  };

  const getLeaveForNextWeek = async (): Promise<void> => {
    await handleRequest(() =>
      LeaveDetailsService.getCoreApiApiAppLeaveDetailsStaffOnLeaveForNextWeek()
    ).then((response) => {
      if (response != null) {
        const sorted = sortByDate(response);
        setLeaveDataForNextWeek(sorted);
      }
    });
  };

  const getLeaveForThisMonth = async (): Promise<void> => {
    await handleRequest(() =>
      LeaveDetailsService.getCoreApiApiAppLeaveDetailsStaffOnLeaveForThisMonth()
    ).then((response) => {
      if (response != null) {
        const sorted = sortByDate(response);
        setleaveDataForThisMonth(sorted);
      }
    });
  };

  React.useEffect(() => {
    void getLeaveForToday();
    void getLeaveForThisWeek();
    void getLeaveForNextWeek();
    void getLeaveForThisMonth();
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number): void => {
    setValue(newValue);
  };

  // PAGINATION
  const handleLimitChangeForToday = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setMaxResultCountForToday(Number(event.target.value));
  };

  const handleLimitChangeForThisWeek = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setMaxResultCountForThisWeek(Number(event.target.value));
  };

  const handleLimitChangeForNextWeek = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setMaxResultCountForNextWeek(Number(event.target.value));
  };

  const handleLimitChangeForThisMonth = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setMaxResultCountForThisMonth(Number(event.target.value));
  };

  const handlePageChangeForToday = (event: any, page: number): void => {
    setPageForToday(page);
    setSkipCountForToday(maxResultCountForToday * page);
  };
  const handlePageChangeForThisWeek = (event: any, page: number): void => {
    setPageForThisWeek(page);
    setSkipCountForThisWeek(maxResultCountForThisWeek * page);
  };
  const handlePageChangeForNextWeek = (event: any, page: number): void => {
    setPageForNextWeek(page);
    setSkipCountForNextWeek(maxResultCountForNextWeek * page);
  };
  const handlePageChangeForThisMonth = (event: any, page: number): void => {
    setPageForThisMonth(page);
    setSkipCountorForThisMonth(maxResultCountForThisMonth * page);
  };

  return (
    <MyProfileContainer>
      <Card sx={{ mb: "1rem", maxHeight: "100%" }} elevation={1}>
        <CardHeader title="On Leave" />

        <Divider />
        <CardContent>
          <Box sx={{ bgcolor: "background.paper", width: "100%" }}>
            <AppBar position="static">
              <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="secondary"
                textColor="inherit"
                variant="scrollable"
                scrollButtons="auto"
                aria-label="full width tabs example"
                allowScrollButtonsMobile
              >
                <Tab
                  label={
                    <Typography variant="body1" color={"white"}>
                      Today
                    </Typography>
                  }
                  {...a11yProps(0)}
                  sx={{
                    width: "25%"
                  }}
                />
                <Tab
                  label={
                    <Typography variant="body1" color={"white"}>
                      This Week
                    </Typography>
                  }
                  {...a11yProps(1)}
                  sx={{
                    width: "25%"
                  }}
                />
                <Tab
                  label={
                    <Typography variant="body1" color={"white"}>
                      Next Week
                    </Typography>
                  }
                  {...a11yProps(2)}
                  sx={{
                    width: "25%"
                  }}
                />
                <Tab
                  label={
                    <Typography variant="body1" color={"white"}>
                      This Month
                    </Typography>
                  }
                  {...a11yProps(3)}
                  sx={{
                    width: "25%"
                  }}
                />
              </Tabs>
            </AppBar>

            <TextField
              label="Search using name or email"
              variant="outlined"
              size="small"
              sx={{ width: "100%", mt: 3 }}
              type="search"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
              }}
            />
            <TabPanel value={value} index={0} dir={theme.direction}>
              <TableContainer component={Paper} sx={{ maxHeight: 550 }}>
                {filteredToday != null && filteredToday?.length > 0 ? (
                  <CustomTable
                    columns={column}
                    data={filteredToday.slice(
                      pageForToday * maxResultCountForToday,
                      pageForToday * maxResultCountForToday + maxResultCountForToday
                    )}
                    fontSize="1.2rem"
                    className="outdated"
                  />
                ) : (
                  <span style={{ alignContent: "center" }}>No Record Available</span>
                )}
              </TableContainer>
              {filteredToday != null && filteredToday?.length > 0 && (
                <CustomPagination
                  component={"div"}
                  count={Number(filteredToday?.length)}
                  onPageChange={handlePageChangeForToday}
                  onRowsPerPageChange={handleLimitChangeForToday}
                  page={pageForToday}
                  rowsPerPage={maxResultCountForToday}
                  rowsPerPageOptions={[5, 10, 15, 20, 25]}
                />
              )}
            </TabPanel>

            <TabPanel value={value} index={1} dir={theme.direction}>
              <TableContainer component={Paper} sx={{ maxHeight: 550 }}>
                {filteredThisWeek != null && filteredThisWeek?.length > 0 ? (
                  <CustomTable
                    columns={column}
                    data={filteredThisWeek.slice(
                      pageForThisWeek * maxResultCountForThisWeek,
                      pageForThisWeek * maxResultCountForThisWeek + maxResultCountForThisWeek
                    )}
                    fontSize="1.2rem"
                    className="outdated"
                  ></CustomTable>
                ) : (
                  <span style={{ alignContent: "center" }}>No Record Available</span>
                )}
              </TableContainer>
              {filteredThisWeek != null && filteredThisWeek?.length > 0 && (
                <CustomPagination
                  component={"div"}
                  count={Number(filteredThisWeek?.length)}
                  onPageChange={handlePageChangeForThisWeek}
                  onRowsPerPageChange={handleLimitChangeForThisWeek}
                  page={pageForThisWeek}
                  rowsPerPage={maxResultCountForThisWeek}
                  rowsPerPageOptions={[5, 10, 15, 20, 25]}
                />
              )}
            </TabPanel>

            <TabPanel value={value} index={2} dir={theme.direction}>
              <TableContainer component={Paper} sx={{ maxHeight: 550 }}>
                {filteredNextWeek != null && filteredNextWeek?.length > 0 ? (
                  <CustomTable
                    columns={column}
                    data={filteredNextWeek.slice(
                      pageForNextWeek * maxResultCountForNextWeek,
                      pageForNextWeek * maxResultCountForNextWeek + maxResultCountForNextWeek
                    )}
                    fontSize="1.2rem"
                    className="outdated"
                  />
                ) : (
                  <span style={{ alignContent: "center" }}>No Record Available</span>
                )}
              </TableContainer>
              {filteredNextWeek != null && filteredNextWeek?.length > 0 && (
                <CustomPagination
                  component={"div"}
                  count={Number(filteredNextWeek?.length)}
                  onPageChange={handlePageChangeForNextWeek}
                  onRowsPerPageChange={handleLimitChangeForNextWeek}
                  page={pageForNextWeek}
                  rowsPerPage={maxResultCountForNextWeek}
                  rowsPerPageOptions={[5, 10, 15, 20, 25]}
                />
              )}
            </TabPanel>

            <TabPanel value={value} index={3} dir={theme.direction}>
              <TableContainer component={Paper} sx={{ maxHeight: 550 }}>
                {filteredThisMonth != null && filteredThisMonth?.length > 0 ? (
                  <CustomTable
                    columns={column}
                    data={filteredThisMonth.slice(
                      pageForThisMonth * maxResultCountForThisMonth,
                      pageForThisMonth * maxResultCountForThisMonth + maxResultCountForThisMonth
                    )}
                    fontSize="1.2rem"
                    className="outdated"
                  ></CustomTable>
                ) : (
                  <span style={{ alignContent: "center" }}>No Record Available</span>
                )}
              </TableContainer>
              {filteredThisMonth != null && filteredThisMonth?.length > 0 && (
                <CustomPagination
                  component={"div"}
                  count={Number(filteredThisMonth?.length)}
                  onPageChange={handlePageChangeForThisMonth}
                  onRowsPerPageChange={handleLimitChangeForThisMonth}
                  page={pageForThisMonth}
                  rowsPerPage={maxResultCountForThisMonth}
                  rowsPerPageOptions={[5, 10, 15, 20, 25]}
                />
              )}
            </TabPanel>
          </Box>
        </CardContent>
      </Card>
    </MyProfileContainer>
  );
}
